import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';
import { getAnalytics } from 'firebase/analytics';

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyDOp54LeVa94F4hZPsFcOlt5dGPsUnfweI",
  authDomain: "mitai-82ba8.firebaseapp.com",
  projectId: "mitai-82ba8",
  storageBucket: "mitai-82ba8.firebasestorage.app",
  messagingSenderId: "419059030065",
  appId: "1:419059030065:web:d82b5f8d59143c4c9f9d10",
  measurementId: "G-LM5XWRTXDP"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize Firebase Analytics
export const analytics = getAnalytics(app);

// Initialize Firebase Authentication and get a reference to the service
export const auth = getAuth(app);

// Initialize Cloud Firestore and get a reference to the service
export const db = getFirestore(app);

export default app;

